/**
 * Whether an extracted field can be pointed at in the document.
 *
 * A grounded field has at least one chunk reference, so the viewer can
 * highlight the exact region its value was read from and a verifier can
 * compare the two. An ungrounded one can only be accepted on trust — the
 * model returned a value with no geometry, and nobody has drawn a highlight
 * for it since.
 *
 * This is not the same question as which page a field belongs to. A field can
 * know its page (from `page_number` or the model's `source_page` report) and
 * still be ungrounded: the operator gets sent to the right sheet with nothing
 * marked on it. Page attribution lives in `bucketFieldsByPage`.
 */
export function isFieldGrounded(field: {
  references?: string[] | null;
}): boolean {
  return (field.references?.length ?? 0) > 0;
}
